export const metrikaHit = (subPage?: string) => {
  try {
    const url = window.location.origin + window.location.pathname + (subPage ? `/${subPage}` : '')

    if (process.env.YM_ID) {
      ym(Number(process.env.YM_ID), 'hit', url)
    }
  }
  catch (e) {
    console.error(e)
  }
}

export const metrikaGoal = async (
  target: string,
  params?: Record<string, any>,
  callback?: () => void,
) => {
  try {
    if (process.env.YM_ID) {
      ym(Number(process.env.YM_ID), 'reachGoal', target, params)
    }

    if (callback) {
      setTimeout(() => {
        callback()
      }, 1000)
    }
  }
  catch (e) {
    console.error(e)
  }
}
